module.exports = __webpack_public_path__ + "img/fig35.86a25664.jpg";